import { createAction, createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_PARTICULAR_EXPENSE: 'GET_PARTICULAR_EXPENSE',
    EXPENSE_SAVE_COMMENT: 'EXPENSE_SAVE_COMMENT',
    EXPENSE_UPDATE_COMMENT: 'EXPENSE_UPDATE_COMMENT'
  }),
  CREATE_NEW_EXPENSE: 'CREATE_NEW_EXPENSE',
  UPDATE_EXPENSE: 'UPDATE_EXPENSE',
  UPDATE_EXPENSE_TABLE: 'UPDATE_EXPENSE_TABLE',
  CHANGE_EXPENSE_STATUS: 'CHANGE_EXPENSE_STATUS',
  CLEAR_EXPENSE_DATA: 'CLEAR_EXPENSE_DATA',
  DELETE_EXPENSE_LINE: 'DELETE_EXPENSE_LINE',
  UPDATE_CLAIM_DATA: 'UPDATE_CLAIM_DATA',
  RESET_NEW_ROW: 'RESET_NEW_ROW'
};

export const getExpense = createAsyncAction(types.GET_PARTICULAR_EXPENSE, (expenseId) => {
  return tneAxiosClient.get(`v1/expense?expenseId=${expenseId}`).then((res) => res.data.Data);
});

export const addNewClaim = createAction(types.CREATE_NEW_EXPENSE);

export const resetNewRow = createAction(types.RESET_NEW_ROW);

export const updateClaim = createAction(types.UPDATE_EXPENSE, (expense) => ({ Data: expense }));

export const updateClaimTable = createAction(types.UPDATE_EXPENSE_TABLE, (expense) => ({ Data: expense }));

export const changeExpenseStatus = createAction(types.CHANGE_EXPENSE_STATUS, (status) => status);

export const clearExpense = createAction(types.CLEAR_EXPENSE_DATA);
export const deleteClaimLineById = createAction(types.DELETE_EXPENSE_LINE, (id) => ({ id }));

export const updateClaimData = createAction(types.UPDATE_CLAIM_DATA, (prop, value) => ({
  Data: { prop, value }
}));

export const saveExpenseComment = createAsyncAction(types.EXPENSE_SAVE_COMMENT, (comment, expenseId) => {
  return tneAxiosClient
    .post(`v1/expense-approver-comment`, { ExpenseId: expenseId, Reason: comment })
    .then((res) => res.data.Data);
});

export const updateExpenseComment = createAsyncAction(types.EXPENSE_UPDATE_COMMENT, (comment, commentId) => {
  return tneAxiosClient
    .put(`v1/expense-approver-comment`, { Id: commentId, Reason: comment })
    .then(() => ({ comment, commentId }));
});
